// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TCreateUpdateManagedUserReq, TUpdateManagedUserReq } from '../types/requests';

export function ManagedUsersController() {
  const getManagedUsers = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/managed-user/users`, {
      headers: getAuthHeaders(),
    });
  };

  const createManagedUser = async <T>(data: TCreateUpdateManagedUserReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/api/v1/managed-user/client-admin`, data, {
      headers: getAuthHeaders(),
    });
  };

  const updateManagedUser = async <T>(data: TUpdateManagedUserReq): Promise<T> => {
    return await axios.patch(`${DEV_APP_API_URL}/api/v1/managed-user/update-by-admin`, data, {
      headers: getAuthHeaders(),
    });
  };

  const deleteManagedUser = async <T>(user_id: number): Promise<T> => {
    return await axios.delete(`${DEV_APP_API_URL}/client-admin/delete?user_id=${user_id}`, {
      headers: getAuthHeaders(),
    });
  };

  return { getManagedUsers, createManagedUser, updateManagedUser, deleteManagedUser };
}
